import { OrganizationTypesEnum, UserRightsEnum, ZoneContextType } from '../../utilities/Constants';

import Authorization from '../../stores/Authorization';
import { CheckmateSameCaseGroupIcon } from '../../shared/CheckmateIcons';
import { ICaseTitleModel } from '../../interfaces/ICase';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { SameCaseStatusType } from '../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';
import { Stack } from 'react-bootstrap';
import { useAuthContext } from '../../contexts/AuthContext';
import { useCheckCaseSameCase } from '../../pages/quad/useCheckCaseSameCase';

interface ICaseNameProps {
    additionalText?: string | React.ReactNode;
    caseGuid?: string;
    caseTitle: ICaseTitleModel;
    openLinkInNewTab?: boolean;
    zoneContext: ZoneContextType;
}

export function CaseName(props: ICaseNameProps) {
    const { user } = useAuthContext();
    const { zoneGuid } = props.zoneContext;
    const isLocalBasicUser = Authorization.isLocalScope(user, zoneGuid);
    const isCompanyUser =
        user?.homeOrganization?.organizationType?.id === OrganizationTypesEnum.Company.Value;

    const { showSameCaseModal } = props.zoneContext;
    const checkSameCaseQuery = useCheckCaseSameCase(props.caseGuid);
    const isCaseApprovedInSameCaseGroup =
        checkSameCaseQuery?.data?.sameCaseStatusTypeId === SameCaseStatusType.Approved;

    const canViewThreatScore = Authorization.userHasRight(
        UserRightsEnum.ViewThreatScore,
        user,
        props.zoneContext.zoneGuid
    );

    const getSQClassName = () => {
        if (!props.caseTitle.SQScore && !props.caseTitle.SQProjection) return '';

        if (props.caseTitle.SQProjection)
            return 'btn-' + props.caseTitle.SQProjection.toLowerCase() + ' ';
        else if (props.caseTitle.SQScore) {
            return 'btn-white ';
        }
    };

    if (!props.caseTitle.caseName) return null;

    return (
        <Stack direction="horizontal" gap={2}>
            <span className={getSQClassName() + 'case-score-display'} style={{ fontSize: '15px' }}>
                {props.caseTitle.SQScore ? props.caseTitle.SQScore : <span>-</span>}
            </span>

            {props.caseTitle.guid ? (
                <Link
                    target={props.openLinkInNewTab ? '_blank' : ''}
                    to={props.zoneContext.buildZoneUrl(
                        LocalRoutes.CaseFile.replace(':guid', props.caseTitle.guid)
                    )}
                >
                    {props.caseTitle.caseName}
                </Link>
            ) : (
                <span>{props.caseTitle.caseName}</span>
            )}

            {!isLocalBasicUser && !isCompanyUser && isCaseApprovedInSameCaseGroup && (
                <CheckmateSameCaseGroupIcon
                    className="text-blue cursor-pointer"
                    onClick={() => showSameCaseModal(checkSameCaseQuery?.data?.sameCaseGuid || '')}
                />
            )}

            {props.caseTitle.priority && (
                <i className="fal fa-exclamation-circle color-yellow" title="Priority" />
            )}

            {canViewThreatScore && (
                <span className="btn-green case-score-display" title="Same Case Group">
                    {props.caseTitle.threatScore ? props.caseTitle.threatScore : <span>-</span>}
                </span>
            )}

            {typeof props.additionalText === 'string' ? (
                <span>{props.additionalText}</span>
            ) : (
                props.additionalText
            )}
        </Stack>
    );
}
